












import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Base } from './base';
import { DateTimeHelper as _dateTime } from '@/helper/date-time.helper';

@Component({
    computed: {
    },
    props: [
        'isShownLoader',
        'text'
    ],
})
export default class SnackBarLoaderComponent extends Base {
    public loader: boolean = false;
    public loaderText: string = 'Loading...';

    public mounted(): void {
        this.loader = this.$props.isShownLoader;
        this.loaderText = this.$props.text;
    }
}

